import { render, staticRenderFns } from "./PositionServer.vue?vue&type=template&id=d64cde46&"
import script from "./PositionServer.vue?vue&type=script&lang=js&"
export * from "./PositionServer.vue?vue&type=script&lang=js&"
import style0 from "./PositionServer.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports